<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader>


<div class="">
  <div class="container" style="padding-top: 13px;">
    <div class="d-flex">
      <div class="col-4">
        <img src="assets/img/backMenu.svg" alt="" (click)="gotoRestoPage()" style="cursor: pointer;">
      </div>
      <div class="col-6">
        <p class="location">Your Location</p>
      </div>
    </div>
  </div>
  <div class="blankLine">
    &nbsp;
  </div>

  <div class="container">
    <div class="searchbar">
      <div style="margin-top: -4px;">
        <span style="padding-left: 10px;"><img src="assets/img/SearchIcon.svg" alt=""></span>
      </div>
      <div>
        <!-- (ngSubmit)="onSubmit(myForm.valid)" -->
        <form [formGroup]="myForm" novalidate>
          <input placeholder="Search a new address..." autocorrect="off" autocapitalize="off" spellcheck="off"
            type="text" class="inptext" #city formControlName="city" (ngModelChange)="modelChanged($event,city)">
        </form>
      </div>
      <div>
        <span><img src="assets/img/closeNew.svg" alt="" (click)="clearValue()" *ngIf="showFilteredResto"></span>
      </div>

    </div>
  </div>

  <!-- <div class="container">
    <div>
      <div class="location-text">Current location</div>
    </div>
    <div class="d-flex marg-t6">
      <div class="loc-text">
        Enable your current location for better services
      </div>
      <div>
        <button type="button" class="btn-enable" (click)="enableCurrentLocation()">Enable</button>
      </div>
    </div>
  </div> -->


  <div class="container">
    <div class="d-flex marg-t6">
      <div style="margin-left: 11px;">
        <img src="../../../../assets/img/user-location.svg" alt="">
      </div>
      <div style="padding-left: 12px">
        <div class="location-text">Current location</div>
        <div class="d-flex">
          <div class="loc-text">
            Enable your current location for better services
          </div>
          <div>
            <button type="button" class="btn-enable" (click)="enableCurrentLocation()">Enable</button>
          </div>

        </div>
      </div>
    </div>
  </div>



















































  <!-- <div class="row row-class main_header">
    <div class="col-8">
      <span class="titles">Edit Profile </span>
    </div>
    <div *ngIf="UserCondition" class="col-4 back" (click)="logout()">
      <span class="icon icofont-logout"></span>
      Logout
    </div>
  </div>
  <div class="row row-class">
    <h6>Share with your friend</h6>
  </div>
  <div class="share_link" align="center" style="margin-top:60px" >
    <h4>Share this link with your friends to compare</h4>
    <p  class="text-center">{{Baselinkshare}}</p>
  </div>
  <br>
    <div class="row share_link" align="center">
      <div class="col-4">
        <a href="">
          <img src="./assets/img/facebook.png" (click)="onclickFb()" alt="">
        </a>
      </div>
      <div class="col-4">
        <a href="">
          <img src="./assets/img/whatsup.png" (click)="onclickwhatapp()" alt="">
        </a>
      </div>
      <div class="col-4">
        <a href="">
          <img src="./assets/img/Twitter.png" (click)="onclickTwitter()" alt="">
        </a>
      </div>
    </div>
  
  <div class="row" style="justify-content: center;  margin-top: 60px; ">
    <a [routerLink]="['../', 'profile']">
      <span class="moreTitle">
        Back to Profile
      </span> </a>
  </div>
  <div class="bottom_nav">
  <div class="row sticky stickyButton" style="padding-top: 5px;padding-bottom: 5px;">
    <div *ngIf="UserCondition" class="footernav h-100  py-2">
      <ul class="nav nav-pills row" style=" padding-left: 0px;padding-right: 0px;width: 100%;">
        <li class="nav-item col-xs-3">
          <a [routerLink]="['../', 'food-menu']" class="nav-link">
            <tc-icon [iconClass]="'icofont-restaurant-menu'" [tcFontSize]="24"></tc-icon>
            <span class="nav__text">Menu</span>
          </a>
        </li>
        <li class="nav-item col-xs-3 ">
          <a [routerLink]="['../',  'order-menu']"  class="nav-link">
            <tc-icon [iconClass]="'icofont-shopping-cart'" [tcFontSize]="25"></tc-icon>
            <span class="nav__text">Cart</span>
          </a>
        </li>
        <li class="nav-item col-xs-3">
          <a [routerLink]="['../',  'order-list']"  class="nav-link">
            <tc-icon [iconClass]="'icofont-food-basket'" [tcFontSize]="26"></tc-icon>
            <span class="nav__text">Orders</span>
          </a>
        </li>&nbsp;&nbsp;
        <li class="nav-item col-xs-3 py-1">
          <a [routerLink]="['../', 'edit-profile']"  class="active nav-link">
            <tc-icon [iconClass]="'icofont-user-alt-5'" [tcFontSize]="22"></tc-icon>
            <span class="nav__text">Profile</span>
          </a>
        </li>
      </ul>
    </div>
    <div *ngIf="!UserCondition" class="footernav h-100 py-2">
      <ul class="nav nav-pills row" style="padding-left: 0px;padding-right: 0px;width: 100%;">
        <li class="nav-item col-xs-3">
          <a [routerLink]="['../', 'food-menu-guest']" routerLinkActive="active" class="nav-link">
            <tc-icon [iconClass]="'icofont-restaurant-menu'" [tcFontSize]="24"></tc-icon>
            <span class="nav__text">Menu</span>
          </a>
        </li>
        <li class="nav-item col-xs-3">
          <a [routerLink]="['../',  'order-menu-guest']" routerLinkActive="active" class="nav-link">
            <tc-icon [iconClass]="'icofont-shopping-cart'" [tcFontSize]="25"></tc-icon>
            <span class="nav__text">Cart</span>
          </a>
        </li>
        <li class="nav-item col-xs-3">
          <a [routerLink]="['../',  'order-list']" routerLinkActive="active" class="nav-link">
            <tc-icon [iconClass]="'icofont-food-basket'" [tcFontSize]="26"></tc-icon>
            <span class="nav__text">Orders</span>
          </a>
        </li>&nbsp;&nbsp;
        <li class="nav-item col-xs-3">
          <a [routerLink]="['../', 'edit-profile']" routerLinkActive="active" class="nav-link">
            <tc-icon [iconClass]="'icofont-user-alt-5'" [tcFontSize]="22"></tc-icon>
            <span class="nav__text">Profile</span>
          </a>
        </li>
      </ul>
    </div>
  </div>    
</div> -->



</div>